import { Component, OnInit } from "@angular/core";
import { DialogService } from "primeng/dynamicdialog";
import { SchoolselectorService } from "../../schoolselector/schoolselectorservice.service";
import { MergeToGroupDialogComponent } from "../merge-to-group-dialog/merge-to-group-dialog.component";
import { ReportService } from "../report.service";
import { ActionTypeService } from "../report-services/action-type.service";
import { DistrictSchoolService } from "../report-services/district-school.service";
import { MergeToGroupRequest } from "../report-services/merge-to-group-request";
import { SchoolGroupService } from "../report-services/school-group.service";
import * as moment from "moment";

@Component({
	selector: "app-district-referrals-by-cohort",
	templateUrl: "./district-referrals-by-cohort.component.html",
	styleUrls: ["./district-referrals-by-cohort.component.css"],
})
export class DistrictReferralsByCohortComponent implements OnInit {
	constructor(
		private selectService: SchoolselectorService,
		private reportService: ReportService,
		//Insert Custom Services Here
		private schoolgroupService: SchoolGroupService,
		private actiontypeService: ActionTypeService,
		private districtschoolService: DistrictSchoolService,
		private dialogService: DialogService
	) {}

	report = {
		SchoolID: 0,
		//Insert Custom Parameters Here
		DistrictSchoolID: 0,
		StartDate: new Date(),
		EndDate: new Date(),
		ActionTypeID: 0,
		SchoolGroupID: 0,
		ShowDetailID: "No",
		ExclusionID: "All",
		ImageLogo: "",
	};

	//Insert Custom Lists Here
	DistrictSchoolList: any = [];
	ActionTypeList: any = [];
	SchoolGroupList: any = [];
	ImageLogoList: any = [];

	SchoolSelectShowAllID: any = 0;
	SchoolSelectShowAllText: any = "All Schools";

	user: any;
	errorMessage: any = "";
	isProcessing: any = false;

	ShowDetailList = [
		//Insert Custom List Items Here
		{
			ShowDetailName: "No",
		},
		{
			ShowDetailName: "Yes",
		},
	];

	ExclusionList = [
		//Insert Custom List Items Here
		{
			ExclusionName: "All",
		},
		{
			ExclusionName: "None",
		},
		{
			ExclusionName: "Suspended Entry",
		},
		{
			ExclusionName: "Emergency Condition",
		},
	];

	OutputTypeID: any = 1;
	OutputTypeList = [
		{
			ID: 1,
			Desc: ".PDF",
		},
		// {
		//     ID: 2,
		//     Desc: ".Doc (Word Document)" //Doesn't seem to work
		// },
		// {
		//     ID: 3,
		//     Desc: ".xls (Excel file)" //Ending Support for xls, just use CSV
		// },
		{
			ID: 4,
			Desc: ".CSV (Excel file)",
		},
		{
			ID: 5,
			Desc: ".RTF (Rich Text File)",
		},
		// {
		//     ID: 6,
		//     Desc: ".XML" //Doesn't seem to work
		// },
		{
			ID: 7,
			Desc: ".HTM (Web Page)",
		},
		// {
		//     ID: 8,
		//     Desc: ".rpt" //Doesn't seem to work
		// },
		// {
		//     ID: 9,
		//     Desc: ".grp" //Doesn't seem to work
		// }
	];

	ReportID: number = 323;
	subscription: any;

	ngOnInit() {
		//Insert Custom Init Methods Here
		// this.loadDistrictSchoolList()

		this.subscription = this.selectService.onSchoolChanged().subscribe((school) => {
			// this.SchoolID = school.SchoolID;
			this.report.DistrictSchoolID = school.SchoolID;
			this.loadLogolist();
		});

		this.loadActionTypeList();
		this.loadSchoolGroupList();
	}

	ngOnDestroy() {
		this.subscription.unsubscribe();
	}

	private loadDistrictSchoolList() {
		this.report.DistrictSchoolID = 0;
		var result = this.districtschoolService.loadDistrictSchoolList("", this.report.SchoolID);
		result.subscribe(
			(response) => {
				this.DistrictSchoolList = response;

				this.report.DistrictSchoolID = this.DistrictSchoolList[0].SchoolID;
			},
			(error) => {}
		);
	}

	private loadActionTypeList() {
		this.report.ActionTypeID = 0;
		var result = this.actiontypeService.loadActionTypeList("", this.report.SchoolID);
		result.subscribe(
			(response) => {
				this.ActionTypeList = response;

				this.report.ActionTypeID = this.ActionTypeList[0].ActionTypeID;
			},
			(error) => {}
		);
	}

	private loadSchoolGroupList() {
		this.report.SchoolGroupID = 0;
		var result = this.schoolgroupService.loadSchoolGroupList("", this.report.SchoolID);
		result.subscribe(
			(response) => {
				this.SchoolGroupList = response;

				this.report.SchoolGroupID = this.SchoolGroupList[0].SchoolGroupID;
			},
			(error) => {}
		);
	}

	private loadLogolist() {
		var result = this.reportService.ImageLogoGetList("", this.report.DistrictSchoolID);
		result.subscribe(
			(response) => {
				this.ImageLogoList = response;

				this.report.ImageLogo = this.ImageLogoList[0].ImageLibraryID;
			},
			(error) => {}
		);
	}

	Print() {
		var component = this;
		this.errorMessage = "";

		//Insert Custom Error Checks Here
		// if (!this.report.DistrictSchoolID) {
		//   this.errorMessage = "Select the DistrictSchool"
		//   return;
		// }

		if (!this.report.StartDate) {
			this.errorMessage = "Select the Start Date";
			return;
		}

		if (!this.report.EndDate) {
			this.errorMessage = "Select the End Date";
			return;
		}

		// if (!this.report.ActionTypeID) {
		//   this.errorMessage = "Select the Action Type"
		//   return;
		// }

		// if (!this.report.SchoolGroupID) {
		//   this.errorMessage = "Select the School Group"
		//   return;
		// }

		if (!this.report.ShowDetailID) {
			this.errorMessage = "Select the Show Detail";
			return;
		}

		if (!this.report.ExclusionID) {
			this.errorMessage = "Select the Exclusion";
			return;
		}

		var strParam = this.GetStrParam();
		this.isProcessing = true;

		var reportID = 323;

		var result = this.reportService.Print(reportID, strParam, this.report.SchoolID, this.OutputTypeID);

		result.subscribe(
			(response: any) => {
				component.isProcessing = false;
				window.open(response);
			},
			(error) => {
				component.errorMessage = error;
				component.isProcessing = false;
			}
		);
	}

	GetStrParam(): string {
		var strParam: string = "";

		//Parameter 1: DistrictSchoolID
		strParam += this.report.DistrictSchoolID + "|DistrictSchoolID";

		//Parameter 2: StartDate
		strParam += "," + moment(this.report.StartDate).format("MM/DD/YYYY") + "|StartDate";

		//Parameter 3: EndDate
		strParam += "," + moment(this.report.EndDate).format("MM/DD/YYYY") + "|EndDate";

		//Parameter 4: ActionType
		strParam += "," + this.report.ActionTypeID + "|ActionType";

		//Parameter 5: SchoolGroupID
		strParam += "," + this.report.SchoolGroupID + "|SchoolGroupID";

		//Parameter 6: ShowDetail
		strParam += "," + this.report.ShowDetailID + "|ShowDetail";

		//Parameter 7: Exclusion
		strParam += "," + this.report.ExclusionID + "|Exclusion";

		//Parameter 8: ImageLogo
		strParam += "," + this.report.ImageLogo + "|Imagelogo";

		return strParam;
	}

	MergeToGroup() {
		this.errorMessage = "";

		this.isProcessing = true;
		var strParam = this.GetStrParam();

		var parms: MergeToGroupRequest = {
			ReportID: this.ReportID,
			SchoolID: this.report.SchoolID,
			strParms: strParam,
		};

		var result = this.reportService.MergeToGroupSelectInfo(parms);
		result.subscribe(
			(response: any) => {
				if (response.length > 0) {
					var ref = this.dialogService.open(MergeToGroupDialogComponent, {
						header: "Merge to Group",
						width: "fit-content",
						data: {
							//INSERT Custom Data here
							lstPerson: response,
							SchoolID: this.report.SchoolID,
						},
					});
					ref.onClose.subscribe((response) => {
						if (response == 1) {
						}
					});
				} else {
					this.errorMessage = "No Data available";
				}

				this.isProcessing = false;
			},
			(error) => {
				this.errorMessage = error;
				this.isProcessing = false;
			}
		);
	}
}
